import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import * as Sentry from '@sentry/browser';
import { isFatalFirestoreError, shouldAttemptRecovery } from './firestore-recovery';


@Injectable()
export class SentryIonicErrorHandler extends ErrorHandler {
  override handleError(error: any) {
    // Fatal Firestore assertion → the client is corrupt; recover the session by
    // reloading (loop-guarded). See firestore-recovery.ts (BAR-HELPER-2Q5/2FY/2KZ).
    if (isFatalFirestoreError(error) && shouldAttemptRecovery(Date.now(), sessionStorage)) {
      console.warn('[Firestore] fatal INTERNAL ASSERTION — reloading to recover the client');
      window.location.reload();
      return;
    }

    super.handleError(error);
    try {
      if (!environment.sentry.disableLogging) {
        Sentry.captureException(error.originalError || error);
      } else {
        console.info('Sentry Logging Disabled');
      }
    } catch (e) {
      console.error(e);
    }
  }
}
